import * as React from "react";
const SvgSuccessIcon = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 44, height: 44, viewBox: "0 0 44 44", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 22, cy: 22, r: 22, fill: "#DBFFE1" }), /* @__PURE__ */ React.createElement("path", { d: "M30 16L19 27L14 22", stroke: "#53A55D", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgSuccessIcon;
